module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_100000_250000.8f6f5081.png";